import React from 'react';

interface PaginationProps {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  totalPages,
  currentPage,
  onPageChange,
}) => {
  const handlePageClick = (page: number) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    onPageChange(page);
  };

  // 生成页码显示逻辑
  const getPages = () => {
    const pages: (number | string)[] = [];

    if (totalPages <= 5) {
      // 总页数<=5，显示所有页码
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      // 总页数>5，根据当前页码决定显示方式
      if (currentPage <= 3) {
        // 当前页在前3页：1 2 3 4 ... 13
        pages.push(1, 2, 3, 4, '...', totalPages);
      } else if (currentPage >= totalPages - 2) {
        // 当前页在后3页：1 ... 10 11 12 13
        pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        // 当前页在中间：1 ... 5 6 7 ... 13
        pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
      }
    }

    return pages;
  };

  return (
    <div className="flex items-center space-x-2">
      {/* 左箭头 - 非第一页时显示 */}
      {currentPage > 1 && (
        <button
          onClick={() => handlePageClick(currentPage - 1)}
          className=" p-10 rounded hover:bg-gray-100"
        >
          ←
        </button>
      )}

      {/* 页码 */}
      {getPages().map((page, i) => (
        page === '...' ? (
          <span key={i} className="px-2">...</span>
        ) : (
          <button
            key={i}
            onClick={() => handlePageClick(page as number)}
            className={`
              mx-[5px] p-10
              ${currentPage === page
                ? ' text-[#000] font-[400]'
              : 'text-[#666] hover:bg-gray-100'
              }
            `}
            > 
            {page}
          </button>
        )
      ))}

      {/* 右箭头 - 非最后一页时显示 */}
      {currentPage < totalPages && (
        <button
          onClick={() => handlePageClick(currentPage + 1)}
          className=" rounded  p-10 hover:bg-gray-100"
        >
          →
        </button>
      )}
    </div>
  );
};

export default Pagination;